import { PagingParameters } from "@/api/dtos";
import { usePersistedState } from "@/hooks/usePersistedState";
import { ReactNode, useEffect } from "react";
import { PaginationContext } from "./PaginationProvider";

export function PaginationProvider({
  children,
  storageKey,
  defaultPageSize = 10,
}: {
  children: ReactNode;
  defaultPageSize?: number;
  storageKey: string;
  persistInSearchParams?: boolean;
}) {
  const [pagination, setPagination] = usePersistedState<PagingParameters>(
    {
      page: 0,
      pageSize: defaultPageSize,
    },
    {
      storageKey: `${storageKey}.pagination`,
    },
  );

  const [lastPosition, setLastPosition] = usePersistedState<number | undefined>(
    undefined,
    {
      storageKey: `${storageKey}.lastPosition`,
    },
  );

  // reset page when pageSize changes
  useEffect(() => {
    setPagination({ page: 0, pageSize: pagination.pageSize });
  }, [setPagination, pagination.pageSize]);

  // ajust the pagination when the last position changes
  useEffect(() => {
    if (lastPosition) {
      setPagination({
        page: Math.floor((lastPosition - 1) / pagination.pageSize),
        pageSize: pagination.pageSize,
      });
    }
  }, [lastPosition, pagination.pageSize, setPagination]);

  return (
    <PaginationContext.Provider
      value={{ pagination, setPagination, lastPosition, setLastPosition }}
    >
      {children}
    </PaginationContext.Provider>
  );
}
